import { REQUIRED } from "@/util/validation-rules"
import { DATE_DEFAULT_REGXP } from "@/util/const"

export default class CMExamConfigValidator {
  constructor(data, validator) {
    this.data = data
    this.validator = validator
  }
  
  validate () {
    this.validator.resetFields()
    return this.isValid()
  }

  isValid() {
    this.validateRequired('name', this.data.name)
    this.validateRequired('number', this.data.number)
    this.validateSlug()
    return this.validator.isValid()
  }

  validateRequired(field, data) {
    let match = REQUIRED(data)
    if(match === true) return true
    this.validator.invalidField(field, match)
    return false
  }

  validateSlug() {
    if(/^[-a-zA-Z0-9_]+$/.test(this.data.slug)) return true
    this.validator.invalidField('slug', 'Should contain only letters and numbers')
  }
}